export const DecimalFilter = (value: number) => {
  return Number(value).toFixed(2).replace('.', ',')
}
